import { getJwt, getRefreshToken, storeJwt } from './localStorage';

import axios from 'axios';

const baseAPI = process.env.REACT_APP_API_BASE_URL;

const instance = axios.create({
  timeout: 600000,
  withCredentials: false,
});

// Garante que múltiplas chamadas paralelas que recebam 401 ao mesmo tempo
// disparem apenas uma chamada de refresh.
let refreshPromise = null;

const exchangeAccessToken = () => {
  if (refreshPromise) return refreshPromise;

  refreshPromise = instance
    .request({
      method: 'post',
      url: baseAPI + '/auth/token',
      data: { refreshToken: getRefreshToken() },
      headers: { Authorization: `Bearer ${getJwt()}` },
      _skipAuthRetry: true,
    })
    .then((response) => {
      storeJwt(response.data.jwt);
      return response.data.jwt;
    })
    .finally(() => {
      refreshPromise = null;
    });

  return refreshPromise;
};

// Em 401, troca o JWT pelo refresh token e tenta a request original uma vez.
instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const status = error.response?.status;
    if (
      status === 401 &&
      originalRequest &&
      !originalRequest._skipAuthRetry &&
      !originalRequest._retried
    ) {
      originalRequest._retried = true;
      try {
        const newJwt = await exchangeAccessToken();
        originalRequest.headers = {
          ...originalRequest.headers,
          Authorization: `Bearer ${newJwt}`,
        };
        return instance.request(originalRequest);
      } catch (refreshError) {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

const getAuthorizationHeader = () => ({
  Authorization: `Bearer ${getJwt()}`,
});

export const unauthenticatedRequest = async ({
  url,
  method,
  queryParams,
  headers = {},
  body,
  isCep,
  ...other
}) => {
  return await _request({
    url,
    isCep,
    method,
    ...other,
    headers: {
      ...headers,
    },
    queryParams,
    body,
  });
};
export const authenticatedRequest = async ({
  url,
  method,
  queryParams,
  body,
  headers,
  base,
  ...other
}) => {
  return await _request({
    url,
    method,
    base,
    ...other,
    headers: {
      ...getAuthorizationHeader(),
      ...headers,
    },
    queryParams,
    body,
  });
};
const _request = async ({
  url,
  base = baseAPI,
  method,
  headers = undefined,
  queryParams = {},
  body,
  isCep,
  ...other
}) => {
  url = isCep ? url : base + url;

  Object.keys(queryParams).forEach(
    (key) =>
      queryParams.hasOwnProperty.call(key) &&
      !queryParams[key] &&
      delete queryParams[key]
  );

  return instance.request({
    url,
    method,
    headers,
    ...other,
    params: queryParams,
    data: body,
  });

};

export default instance;

export const handleApiErrors = (response) => response;
